import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-px-1 tw-py-2 tw-w-32" }
const _hoisted_2 = { class: "tw-px-1 tw-py-2 tw-w-32 dispatch-trip-edit-scheduled-date" }
const _hoisted_3 = { class: "tw-px-1 tw-py-2 tw-w-56" }
const _hoisted_4 = { class: "tw-px-1 tw-py-2 tw-w-56" }
const _hoisted_5 = { class: "tw-px-1 tw-py-2 tw-w-56" }
const _hoisted_6 = { class: "tw-px-1 tw-py-2 tw-w-36" }
const _hoisted_7 = { class: "tw-whitespace-nowrap tw-px-0 tw-py-2" }
const _hoisted_8 = { class: "tw-flex tw-justify-end tw-items-center tw-gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _cache[6] || (_cache[6] = _createElementVNode("td", { class: "tw-whitespace-nowrap tw-w-7 tw-px-2 tw-py-2 tw-text-slate-700" }, "+", -1)),
    _createElementVNode("td", _hoisted_1, [
      _createVNode(_component_FilterableDropdown, {
        autofocus: "",
        placeholder: "Trip Type",
        modelValue: _ctx.editingTrip.type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editingTrip.type) = $event)),
        options: _ctx.tripTypes,
        clearable: false,
        searchable: true,
        size: "sm"
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("td", _hoisted_2, [
      _createVNode(_component_DatePicker, {
        class: "tw-block",
        "input-class": 'tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55',
        format: "MM/DD/YYYY",
        modelValue: _ctx.editingTrip.scheduledDate,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingTrip.scheduledDate) = $event)),
        "show-days-shortcuts": true,
        "controls-placement": "popup"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("td", _hoisted_3, [
      _createVNode(_component_FilterableDropdown, {
        placeholder: "Origin",
        modelValue: _ctx.editingTrip.origin,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editingTrip.origin) = $event)),
        customLabel: (x) => (x.shortName ? x.shortName : x.name),
        options: (_ctx.originCustomers || []).concat(_ctx.terminals || []),
        clearable: false,
        searchable: true,
        size: "sm",
        onSearchChange: _ctx.onOriginCustomerSearch
      }, null, 8, ["modelValue", "customLabel", "options", "onSearchChange"])
    ]),
    _createElementVNode("td", _hoisted_4, [
      _createVNode(_component_FilterableDropdown, {
        placeholder: "Destination",
        modelValue: _ctx.editingTrip.destination,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingTrip.destination) = $event)),
        customLabel: (x) => (x.shortName ? x.shortName : x.name),
        options: (_ctx.destinationCustomers || []).concat(_ctx.terminals || []),
        clearable: false,
        searchable: true,
        size: "sm",
        onSearchChange: _ctx.onDestinationCustomerSearch
      }, null, 8, ["modelValue", "customLabel", "options", "onSearchChange"])
    ]),
    _createElementVNode("td", _hoisted_5, [
      _createVNode(_component_FilterableDropdown, {
        placeholder: "Driver",
        modelValue: _ctx.editingTrip.driver,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingTrip.driver) = $event)),
        label: "fullName",
        options: _ctx.filterDrivers,
        clearable: true,
        searchable: true,
        size: "sm"
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("td", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55",
        placeholder: "Chassis Number",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingTrip.chassis) = $event))
      }, null, 512), [
        [_vModelText, _ctx.editingTrip.chassis]
      ])
    ]),
    _createElementVNode("td", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Button, {
          isGreen: true,
          onClick: _ctx.confirmAddTrip,
          class: "tw-h-9 tw-w-9 tw-p-0",
          icon: "check",
          title: "Confirm add trip",
          "aria-label": "Confirm add trip"
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          isRed: true,
          isSecondary: true,
          onClick: _ctx.cancelTripAddition,
          class: "tw-ml-1 tw-h-9 tw-w-9 tw-p-0",
          icon: "xmark",
          title: "Cancel add trip",
          "aria-label": "Cancel add trip"
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}